import { useEffect } from "react";

const TermsConditions = () => {
  useEffect(() => {
    document.title = "Terms & Conditions - Deww Botanicals";
  }, []);

  return (
    <>
      <div
        className="container-fluid page-header"
          style={{ backgroundImage: `url(../assets/images/banner-about.jpg)` }}
      >
        <div className="container">
          <h1 className="display-5 mb-3 animated slideInDown">
            Terms & Conditions
          </h1>
        </div>
      </div>

      <div className="container-xxl py-3 container-fluid p-0 mb-5 blog-wrapper">
        <div className="container">
          <div className="row my-3">
            <div className="col-12 col-md-7 m-auto">
              <p>
                Welcome to Deww Botanicals. By accessing or using our website,
                placing an order, or engaging with our products and services in
                any manner, you agree to be bound by the following Terms and
                Conditions. Please read them carefully.
              </p>
              <h3>Company Overview</h3>
              <p>
                Deww Botanicals specializes in the manufacturing and supply of
                natural and botanical products, including but not limited to:
              </p>
              <ul>
                <li>Essential Oils</li>
                <li>Carrier Oils</li>
                <li>Liquid Extracts</li>
                <li>Spice Oils</li>
                <li>Natural Butters</li>
                <li>Floral Waters</li>
              </ul>
              <h3>Product Use Disclaimer</h3>
              <ul>
                <li>
                  All products offered by Deww Botanicals are intended for
                  external use only unless otherwise specified.
                </li>
                <li>
                  Our products are not intended to diagnose, treat, cure, or
                  prevent any disease.
                </li>
                <li>
                  It is the customer’s responsibility to ensure the suitability
                  of a product before use.
                </li>
                <li>
                  Always conduct a patch test before applying the full product.
                </li>
                <li>
                  Products must be handled and used according to applicable
                  safety guidelines and regulations.
                </li>
              </ul>
              <h3>Ordering & Payment</h3>
              <ul>
                <li>
                  Orders can be placed via our website, email, or authorized
                  sales channels.
                </li>
                <li>
                  All payments must be made in full before the dispatch of goods
                  unless prior credit arrangements have been made.
                </li>
                <li>Prices are subject to change without prior notice.</li>
              </ul>

              <h3>Shipping & Delivery</h3>
              <ul>
                <li>
                  We strive to dispatch products within the committed time
                  frame. However, delays may occur due to unforeseen
                  circumstances.
                </li>
                <li>
                  Shipping charges and responsibilities vary based on location
                  and order size.
                </li>
                <li>
                  Risk of loss and title for products passes to the buyer upon
                  delivery to the carrier.
                </li>
              </ul>
              <h3>Returns & Refunds</h3>
              <ul>
                <li>
                  Returns are accepted only for damaged or incorrectly shipped
                  items and must be reported within 7 days of delivery.
                </li>
                <li>
                  Returned items must be unopened and in original condition.
                </li>
                <li>
                  Refunds will be processed only after the return is received
                  and inspected.
                </li>
              </ul>
              <h3>Quality Assurance</h3>
              <ul>
                <li>
                  Deww Botanicals ensures the highest standards of quality and
                  hygiene in the manufacturing and packaging of its products.
                </li>
                <li>
                  Due to the natural origin of ingredients, variations in color,
                  aroma, and consistency may occur.
                </li>
              </ul>
              <h3>Intellectual Property</h3>
              <ul>
                <li>
                  All content, including product names, logos, packaging
                  designs, and website materials, is the intellectual property
                  of Deww Botanicals.
                </li>
                <li>
                  Unauthorized use or reproduction is strictly prohibited.
                </li>
              </ul>

              <h3>Limitation of Liability</h3>
              <p>
                Deww Botanicals shall not be liable for any direct, indirect,
                incidental, or consequential damages resulting from the use or
                misuse of any of its products.
              </p>
              <h3>Privacy Policy</h3>
              <p>
                Personal and business information collected from customers will
                be used solely for order processing, communication, and the
                improvement of services.
              </p>
              <p>
                We do not sell or share customer information with third parties
                without consent, except as required by law.
              </p>
              <h3>Governing Law</h3>
              <p>
                The laws of India govern these Terms and Conditions. Any
                disputes shall be subject to the exclusive jurisdiction of the
                courts.
              </p>
              <h3>Modifications</h3>
              <p>We reserve the right to modify these Terms and Conditions</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsConditions;
